import React from 'react';
import './Login.css'; // Reuse Login styles

function AccessDenied() {
  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">Access Denied</h1>
        <div className="access-denied-message">
          <div className="error-icon" style={{ fontSize: '48px', marginBottom: '20px', color: '#f44336' }}>
            🚫
          </div>
          <p style={{ marginBottom: '20px', fontSize: '16px', lineHeight: '1.6' }}>
            Your account is not authorized to access this application.
          </p>
          <p style={{ marginBottom: '30px', fontSize: '14px', color: '#666' }}>
            Please contact your system administrator to request access permissions.
          </p>
          <div style={{ padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '4px', marginTop: '20px' }}>
            <p style={{ margin: 0, fontSize: '13px', color: '#666' }}>
              <strong>Need help?</strong> Contact your administrator with your email address to be added to the whitelist.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccessDenied;
